import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=81e300ee&"
import script from "./x-icon.ts?vue&type=script&lang=js&"
export * from "./x-icon.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports